module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAaCAYAAAC3g3x9AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEVSURBVHgB7ZXPbcIwFMa/Z9KKHtqGDXIMPbFBSf/cOwKdgBGASRiBBQKBCeBGjtkAIyQQEuSRIEAIrMgQw4mflOjJiX7+7CfZ5HQmdvFN1MFchQYMyGWB/yOvJFXfyfWnbSKu4RIYo0WBPZWUyl3JuzoCJU+2qJK87SzpQcigZvj93srylX0ZJJNWs5IK5IFQeVlT4AQT24xQIc0vPJGaER5JzQl3UuuS/8c/tqcad7vTBoGbaW024S2EyiW7vdknNAi/XgdaQuJ1H3rQ6cB9lswxe7gSpTD8LfVhUvhoSn6hmaYwHN1mnBHHzn436cOXQ6bt5WOCSJCwammBnCQBpXi2/rZB06O7uLo+pWDI+ROi9PbbALt3cJp8LsX8AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/importsIcons/file_document.png
// module id = ./src/assets/importsIcons/file_document.png
// module chunks = 1